"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clip = clip;
function clip(x, a, b) {
    var _a;
    if (a > b) {
        // swap to ensure valid interval
        _a = [b, a], a = _a[0], b = _a[1];
    }
    return Math.min(Math.max(x, a), b);
}
